import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';

import Table from '@RHEnvironmental/pattern-library/dist/js/components/Table';
import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';
import MainLayout from '../../modules/MainLayout';
import ScrollableArea from '../../modules/ScrollableArea';

import * as providerManagementActions from '../../../actions/providerManagement';
import date from '../../../services/ui/date';
import navigator from '../../../services/ui/navigator';

const ServiceProviderManagement = ({
    getAllServiceProviders,
    serviceProviders,
}) => {
    useEffect(() => {
        getAllServiceProviders();
    }, []);
    return (
        <MainLayout>
            <PageSection className="page-section--fixed-width-container page-section--green">
                <PageHeading level={5} className="mb-4">
                    Platform Admin
                </PageHeading>
                <div className="mb-8">
                    <PageHeading level={4} className="mb-4">
                        Service Provider management
                    </PageHeading>
                </div>
            </PageSection>
            <PageSection className="page-section--fixed-width-container">
                <div className="flex space-between align-baseline">
                    <PageHeading level={5} className="mb-4">
                        Service Providers
                    </PageHeading>
                    <Button
                        onClick={() =>
                            navigator.push('/platform-admin/service-providers')
                        }
                    >
                        Add Service Provider
                    </Button>
                </div>
                {serviceProviders.length <= 0 ? (
                    <LoadingIndicator show />
                ) : (
                    <ScrollableArea>
                        <Table className="table--full-width" hasHover={{ background: true }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Contact Email</th>
                                    <th>Contact Name</th>
                                    <th>Contact Phone</th>
                                    <th>Joined</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceProviders.map((provider) => (
                                    <tr
                                        key={provider.id}
                                        onClick={() =>
                                            navigator.push(
                                                `/platform-admin/service-providers/${provider.id}`
                                            )
                                        }
                                    >
                                        <td data-th="">{provider.name}</td>
                                        <td data-th="">
                                            {provider.contact_email}
                                        </td>
                                        <td data-th="">
                                            {provider.contact_name}
                                        </td>
                                        <td data-th="">
                                            {provider.contact_phone}
                                        </td>
                                        <td data-th="">
                                            {date.short(provider.created_at)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ScrollableArea>
                )}
            </PageSection>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    ...state.pages.providerManagement,
});

const mapDispatchToProps = (dispatch) => ({
    getAllServiceProviders() {
        dispatch(providerManagementActions.getAllServiceProviders());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ServiceProviderManagement);
